import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { CONTACT_EMAIL } from "../../data/site";

export default function FinalCTA() {
    return (
        <section
            data-testid="final-cta-section"
            className="relative overflow-hidden bg-gradient-to-br from-brand-dark via-brand to-blue-500 py-28 sm:py-36"
        >
            <div
                className="pointer-events-none absolute inset-0 opacity-[0.15]"
                style={{
                    backgroundImage:
                        "linear-gradient(rgba(255,255,255,0.25) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.25) 1px, transparent 1px)",
                    backgroundSize: "72px 72px",
                }}
                aria-hidden="true"
            />
            <div
                className="pointer-events-none absolute -right-24 -top-24 h-[420px] w-[420px] rounded-full bg-white/10 blur-[120px]"
                aria-hidden="true"
            />
            <div className="relative mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
                <Reveal>
                    <p className="mb-8 flex items-center gap-3 font-mono text-xs font-semibold uppercase tracking-[0.28em] text-blue-100">
                        <span className="h-px w-8 bg-white/60" aria-hidden />
                        Next step
                    </p>
                    <h2 className="max-w-4xl font-display text-4xl font-bold leading-[1.05] tracking-tight text-balance text-white sm:text-6xl lg:text-7xl">
                        Have something worth building?
                    </h2>
                    <p className="mt-8 max-w-2xl text-base leading-relaxed text-blue-100 sm:text-lg">
                        Tell us what you're working on. We'll help turn the idea into a clear
                        technical plan and a product that works.
                    </p>
                    <div className="mt-12 flex flex-wrap items-center gap-6">
                        <Link
                            to="/contact"
                            data-testid="cta-start-project-btn"
                            className="group flex items-center gap-2.5 rounded-full bg-white px-8 py-4 text-sm font-semibold text-brand-dark shadow-hover transition-[background-color,transform,box-shadow] duration-300 hover:bg-blue-50 active:scale-95"
                        >
                            Start a Project
                            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                        </Link>
                        <div>
                            <a
                                href={`mailto:${CONTACT_EMAIL}`}
                                data-testid="cta-email-link"
                                className="font-mono text-sm tracking-wide text-white underline decoration-white/40 underline-offset-8 transition-colors duration-300 hover:decoration-white"
                            >
                                {CONTACT_EMAIL}
                            </a>
                            <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.18em] text-blue-200">
                                Placeholder inbox — replace once configured
                            </p>
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
